export const ProficiancyStatus = {
    NOT_STARTED: 0,
    IN_PROGRESS: 1,
    COMPLETED: 2,
    ERROR: 3
}